import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e1d4e17"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-text": "正在保存数据，请稍后",
  style: {"min-height":"500px"}
}
const _hoisted_2 = { class: "cl-amount" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"0 20px","flex":"1 1 10%"} }, "至", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存配置")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("关闭")

import { reactive, ref, unref, nextTick, onMounted } from 'vue';
import { ElMessage, FormRules, ElForm } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useDictionary } from '@/store/dictionary.store';
import { GetDetailApi, ConfigCreateApi, ConfigEditApi } from '../../../apis/ct_categorys_config/categorycfg.api';
import { GetMainstaySelectApi } from '@/apis/basics/mainstay.api';
import { GetDeptListApi } from '../../../apis/systems/systems.api';
import { CtCategoryCfgBase } from '../../../apis/ct_categorys_config/categorycfg.dto';
import { DeptDetailDto } from '../../../apis/systems/systems.dto';
import UserSelect from '@/components/selected/Users/Index.vue';


export default /*#__PURE__*/_defineComponent({
  emits: ['saveData'],
  setup(__props, { expose, emit: $emits }) {

const { getName } = useDictionary();


const loading = ref<boolean>(false);
const isEditor = ref<boolean>(false);
const showDialog = ref<boolean>(false);

const deptList = ref<DeptDetailDto[]>([]);
const mainstayList = ref<any[]>([]);

const elFormRef = ref<ComponentRef<typeof ElForm>>();

const formRules = reactive<FormRules>({
	node_id: [{ required: true, message: '审批节点不能留空', trigger: 'blur' }],
	rule_name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
	mainstay_id: [{ required: true, message: '主体名称未选择', trigger: 'blur' }],
});

const formSchema = ref<CtCategoryCfgBase>({
	id: '',
	revision: '',
	category_id: '',
	rule_name: '',
	is_enabled: 'Y',
	remark: '',
	node_id: '',
	mainstay_id: '',
	amount_min: 0,
	amount_max: 0,
	tips: '',
	is_use_oa: 'N',
	specify_list: [],
});

/* 需要处理加载的数据 */
const load = {
	/* 我方主体选择数据 */
	getMainstaySelectList: async () => {
		const { succeeded, errors, data } = await GetMainstaySelectApi('');

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			mainstayList.value = data || [];
		}
	},

	/* 获取部门列表 */
	getDeptList: async () => {
		const { succeeded, errors, data } = await GetDeptListApi({ search_key: '', mainstay_id: '' });

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			deptList.value = data || [];
		}
	},
};

/* 获取合同分类信息 */
const getCategoryCfgInfo = async (rowId: string) => {
	loading.value = true;

	const { succeeded, errors, data } = await GetDetailApi(rowId);

	if (!succeeded) {
		ElMessage.error(errors);
	} else {
		formSchema.value = data;
		unref(formSchema).specify_list = data.specify_list || [];
	}

	loading.value = false;
};

/* 用户操作 */
const actions = {
	/* 创建配置 */
	showCreate: (categoryId: string) => {
		formSchema.value = Object.assign({
			category_id: categoryId,
			id: '',
			reactive: '0',
			rule_name: '',
			is_enabled: 'Y',
			remark: '',
			node_id: '',
			mainstay_id: '',
			amount_min: 0,
			amount_max: 0,
			tips: '',
			is_use_oa: 'N',
			specify_list: [],
		});

		isEditor.value = false;
		loading.value = false;
		showDialog.value = true;
	},

	/* 修改配置 */
	showEditor: (rowId: string) => {
		getCategoryCfgInfo(rowId);

		isEditor.value = true;
		showDialog.value = true;
	},

	// showRelDialog: () => {
	//     const schema = unref(formSchema)
	//     unref(userWriterRef)?.showDialog(schema.id);
	// }
};

/* 点击保存按钮 */
const onSaveBtnClick = async () => {
	unref(elFormRef)?.validate(async (isValid: boolean) => {
		if (!isValid) return;

		loading.value = true;

		const formDatas = unref(formSchema);

		const apis = unref(isEditor) ? ConfigEditApi : ConfigCreateApi;
		const { succeeded, errors } = await apis(formDatas);

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success(`保存成功`);
			showDialog.value = false;

			$emits('saveData');
		}
		loading.value = false;
	});
};

expose({
	create: actions.showCreate,
	modify: actions.showEditor,
});

onMounted(() => {
	load.getMainstaySelectList();
	load.getDeptList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showDialog).value = $event)),
    title: isEditor.value ? '编辑配置' : '创建配置',
    style: {"width":"800px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: loading.value,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "info",
        disabled: loading.value,
        onClick: _cache[10] || (_cache[10] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: formSchema.value,
          "label-width": "100px",
          "label-position": "right",
          rules: _unref(formRules)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "规则名称",
                      prop: "rule_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.rule_name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.rule_name) = $event)),
                          placeholder: "请输入规则名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "适用主体",
                      prop: "mainstay_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          style: {"width":"100%"},
                          modelValue: formSchema.value.mainstay_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.mainstay_id) = $event)),
                          filterable: "",
                          placeholder: "请选择我方主体"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainstayList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "审批节点",
                      prop: "node_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.node_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.node_id) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getName)('OA_199'), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.name,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "金额区间" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_el_input_number, {
                            style: {"flex":"1 1 45%"},
                            modelValue: formSchema.value.amount_min,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.amount_min) = $event)),
                            min: "0",
                            precision: 2
                          }, null, 8, ["modelValue"]),
                          _hoisted_3,
                          _createVNode(_component_el_input_number, {
                            style: {"flex":"1 1 45%"},
                            modelValue: formSchema.value.amount_max,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.amount_max) = $event)),
                            min: 0,
                            precision: 2
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "指定审批人员" }, {
                      default: _withCtx(() => [
                        _createVNode(UserSelect, {
                          modelValue: formSchema.value.specify_list,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.specify_list) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "提示信息",
                      prop: "tips"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "100",
                          modelValue: formSchema.value.tips,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.tips) = $event)),
                          rows: "3",
                          placeholder: "审批用户选择提示信息"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "150",
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.remark) = $event)),
                          rows: "3",
                          placeholder: "备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "是否启用",
                      prop: "is_enabled"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "使用OA配置",
                      prop: "is_use_od"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_use_oa,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.is_use_oa) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})